import { MultiLingualToast } from "./MultiLingualToast";
import { useAtom } from "jotai";
import { multiLingualToastOpenVar } from "@/variables/globalVar";

export function MultiLingualToastContainer() {
  const [multiLingualToastOpen, setMultiLingualToastOpenVar] = useAtom(
    multiLingualToastOpenVar,
  );

  return (
    multiLingualToastOpen && (
      <MultiLingualToast onClose={() => setMultiLingualToastOpenVar(false)} />
    )
  );
}
